EmployerTypeApp.Models.Override = Backbone.Model.extend({
    
    url: function() {
        return "/admin/employer-type-override"
    },
    
    defaults: {
        feeds: ['initial state']
    },

    parse: function (data) {
        var model = {};
        model.feeds = data;
        return model;
    }
});